"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClipByGuid = getClipByGuid;
exports.getClipByTime = getClipByTime;
exports.getClipByIndex = getClipByIndex;
exports.normalizeClipObject = normalizeClipObject;
exports.getClipUiTimes = getClipUiTimes;
exports.getClipPropsForReports = getClipPropsForReports;
exports.countFreePremiumClips = countFreePremiumClips;
exports.getClipFilterColor = getClipFilterColor;
exports.normalizeClipCrop = normalizeClipCrop;
exports.getClipPreviewUrls = getClipPreviewUrls;
exports.getClipStart = getClipStart;
exports.getClipEnd = getClipEnd;
exports.getClipStartDuration = getClipStartDuration;
exports.isShortClip = isShortClip;
exports.getClipByType = getClipByType;
exports.getClipCenteredCrop = getClipCenteredCrop;
exports.getClipTimingByOffset = getClipTimingByOffset;
exports.CLIP_TYPE = void 0;

var _mathUtils = require("./math-utils");

var _colorUtils = require("./color-utils");

var _fiterDefaultColor = require("../const/fiter-default-color");

var _ratioUtils = require("./ratio-utils");

const CLIP_TYPE = {
  PHOTO: 'photo',
  VIDEO: 'video'
};
exports.CLIP_TYPE = CLIP_TYPE;
const SHORT_CLIP_DURATION = 1.6;

function isShortClip(clip) {
  return getClipEnd(clip) - getClipStart(clip) <= SHORT_CLIP_DURATION;
}

function getClipStart(clip) {
  const {
    timeline: {
      start: {
        timestamp
      }
    }
  } = clip;
  return timestamp;
}

function getClipStartDuration(clip) {
  const {
    timeline: {
      start: {
        transitionDuration
      }
    }
  } = clip;
  return transitionDuration;
}

function getClipEnd(clip) {
  const {
    timeline: {
      end: {
        timestamp
      }
    }
  } = clip;
  return timestamp;
}

function getClipByGuid(data, guid) {
  return data.find(item => item.guid === guid);
}

function getClipByTime(data, time) {
  let index = 0;
  let guid;

  while (!guid && data[index]) {
    const clip = data[index];
    const start = getClipStart(clip);
    const end = getClipEnd(clip);

    if (time >= start && time <= end) {
      guid = clip.guid;
    }

    index++;
  }

  return guid;
}

function getClipByIndex(data, index) {
  let guid;
  const clip = data[index];

  if (clip) {
    guid = clip.guid;
  }

  return guid;
}

function getClipByType(data, type) {
  const arr = [];
  data.forEach(clip => {
    if (clip.type === type) {
      arr.push(clip.guid);
    }
  });
  return arr;
}

function normalizeClipObject(clip) {
  // pick relevent attr
  const normalizeClip = _.pick(clip, ['type', 'guid', 'timeline', 'video', 'photo', 'crop', 'animation', 'thumbnail', 'filter']); // set default clip type


  if (!normalizeClip.type) {
    normalizeClip.type = CLIP_TYPE.VIDEO;
  }

  if (normalizeClip.type === CLIP_TYPE.PHOTO) {
    normalizeClip.thumbnail = normalizeClip.photo.thumbnailUrl;
    delete normalizeClip.timeline.start.fadeDuration;
    delete normalizeClip.timeline.end.fadeDuration;
    normalizeClip.source = normalizeClip.photo.source;
    normalizeClip.id = normalizeClip.photo.id;
  } else {
    // add offset to timeline object
    normalizeClip.timeline.offset = clip.start;
    normalizeClip.source = normalizeClip.video.source;
    normalizeClip.id = normalizeClip.video.videoId; // remove tag from video object

    if (normalizeClip.video && normalizeClip.video.tags) {
      delete normalizeClip.video.tags;
    }
  }

  normalizeClip.crop = normalizeClipCrop(normalizeClip.crop);
  return normalizeClip;
}

function normalizeClipCrop(crop) {
  if (crop) {
    return { ...crop,
      h: parseFloat(crop.h),
      w: parseFloat(crop.w),
      x: parseFloat(crop.x),
      y: parseFloat(crop.y)
    };
  }

  return crop;
}

function getClipUiTimes(clip, nextClip, index) {
  const startTransitionDuration = clip.type === CLIP_TYPE.PHOTO && index === 0 ? 0 : clip.timeline.start.transitionDuration / 2;
  const endTransitionDuration = nextClip ? nextClip.timeline.start.transitionDuration / 2 : 0;
  let trimStart;
  let trimEnd;

  if (clip.type === CLIP_TYPE.VIDEO) {
    trimStart = clip.start + startTransitionDuration;
    trimEnd = clip.end - endTransitionDuration;
  } else {
    trimStart = clip.timeline.start.timestamp;
    trimEnd = clip.timeline.end.timestamp - endTransitionDuration;
  }

  const duration = trimEnd - trimStart;
  const timelineStart = clip.timeline.start.timestamp + startTransitionDuration;
  const timelineEnd = timelineStart + duration;
  const uiTimes = {
    timeline: {
      offset: clip.type === CLIP_TYPE.VIDEO ? trimStart : 0,
      start: {
        timestamp: (0, _mathUtils.fixedNum)(timelineStart, 2),
        transitionDuration: (0, _mathUtils.fixedNum)(startTransitionDuration, 2)
      },
      end: {
        timestamp: (0, _mathUtils.fixedNum)(timelineEnd, 2),
        transitionDuration: (0, _mathUtils.fixedNum)(endTransitionDuration, 2)
      }
    }
  };
  return uiTimes;
}

function countFreePremiumClips(clips) {
  return clips.filter(clip => clip.photo ? clip.photo.isFreeCollectionPremium : clip.video.isFreeCollectionPremium).length;
}

function getClipFilterColor(filter) {
  if (filter) {
    if (filter.type === 'color') return (0, _colorUtils.rgbaToString)(filter.color); // TODO if (filter.type === 'linearGradient') return filter.stops.map(stop => rgbaToString(stop));
  }

  return undefined;
}

function getClipPropsForReports(clips) {
  // disregard clips that has undefined/'none' filter
  const clipsFilters = _.chain(clips).map('filter').compact().reject({
    type: 'none'
  }).value();

  const countOfClipColorUsed = clipsFilters.length;

  const countOfUniqueClipColorUsed = _.uniq(clipsFilters.map(filter => JSON.stringify(filter))).length;

  const clipColorArray = clipsFilters.map(filter => {
    let color = getClipFilterColor(filter);

    if (_fiterDefaultColor.FILTER_COLORS.includes(color)) {
      color += ' (default)';
    }

    return color;
  });
  const opacityPercentages = clipsFilters.map(filter => (0, _mathUtils.numberRound)('round', filter.color.a * 100, 5) / 100);
  return {
    countOfFreePremiumClips: countFreePremiumClips(clips),
    isMulti: clips.length > 1,
    numClips: clips.length,
    countOfClipColorUsed,
    countOfUniqueClipColorUsed,
    clipColorArray,
    opacityPercentages
  };
}

function getClipPreviewUrls(video) {
  const {
    smallPreviewUrl,
    previewUrl
  } = video;
  return {
    sd: smallPreviewUrl,
    hd: previewUrl
  };
}

function getClipCenteredCrop(video, originalRatio) {
  const originalRatioObject = (0, _ratioUtils.getRatioObjectBy)('ratio', originalRatio);
  const videoRatioObject = (0, _ratioUtils.getRatioObjectBy)('ratio', video.ratio);
  return {
    x: Math.abs(videoRatioObject.width / 2 - originalRatioObject.width / 2),
    y: 0,
    w: originalRatioObject.width,
    h: originalRatioObject.height,
    sourceVideoId: video.videoId,
    source: video.source,
    aspectRatio: originalRatio
  };
}

function getClipTimingByOffset(start, end, offset) {
  const duration = end - start;
  return {
    start: offset,
    end: offset + duration
  };
}